const displayOnMultiSelectFilter = () => {
    return (input) => {
        let output = input;
        if (output.length > 22) {
            return output.substring(0, 22) + "...";
        }
        else {
            return output;
        }
    };
};
const ɵ0 = displayOnMultiSelectFilter;
export const DisplayOnMultiSelectFilter = {
    name: 'displayOnMultiSelectFilter',
    filter: displayOnMultiSelectFilter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-display-on-multi-select.filter.js.map